import {useTranslation} from 'react-i18next';

import {Box, Grid, Typography} from '@mui/material';

import {EmpionSkillsInputField} from '../../../../../../../../../components/EmpionSkillsInputField/EmpionSkillsInputField';

interface AboutTheJobFieldsSkillsProps {
  formik: any;
}

export const AboutTheJobFieldsSkills = ({formik}: AboutTheJobFieldsSkillsProps) => {
  const {t} = useTranslation();

  return (
    <Box sx={{mb: 5}}>
      <Grid item>
        <Typography variant='h4' gutterBottom component='div'>
          {t('companyJobPostings.newJobDialog.formLabels.skills')}*
        </Typography>
      </Grid>
      <Grid item>
        <EmpionSkillsInputField formik={formik} autocompleteOptions={[]} />
      </Grid>
    </Box>
  );
};
